
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const ComparisonTable = () => {
  const { t } = useTranslation("landing");
  
  const comparisonData = [
    {
      feature: "Adgang til udbudsdata",
      traditional: "Begrænset til lokale markeder, manuel søgning, ingen eller meget begrænset integration",
      offertio: "Alle EU-udbud samlet i en udbudsportal med avanceret filtrering via integrationer til udbudsdatabaser"
    },
    {
      feature: "Finde udbud og få notifikationer",
      traditional: "Tidskrævende, manuel søgning, manuel ajourføring af deadlines og opdateringer",
      offertio: "Udbudsagent, der overvåger markedet, sender automatiske notifikationer om relevante udbud direkte i indbakken"
    },
    {
      feature: "Oversættelser",
      traditional: "Dyre eksterne oversættelsestjenester med lange leveringstider",
      offertio: "Professionel oversættelse af alle udbudsdokumenter på 24+ sprog, inkl. tekniske og juridiske termer"
    },
    {
      feature: "Analyser og markedsoverblik",
      traditional: "Begrænset til interne analyser og sporadisk indsigt",
      offertio: "Dashboard og analyser der giver jer dybdegående indblik i udbud og udbudsmateriale, indsigt i konkurrenter samt kommende kontrakter"
    },
    {
      feature: "Bistand og sparring",
      traditional: "Ekstern rådgivning til høje priser, høj behandlingstid",
      offertio: "Juridisk hotline der skærer ned på advokat- og konsulent-udgifterne. Din hurtige livline."
    },
    {
      feature: "Sagsstyringssystem",
      traditional: "Ingen centraliseret styring, ofte spredte dokumenter og opgaver i mails og lokale mapper",
      offertio: "Indbygget sagsstyringssystem til at samle dokumenter, opgaver, deadlines og status ét sted for hele tilbudsprocessen"
    }
  ];

  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section className="py-14 px-4 bg-gray-50">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-2xl md:text-3xl font-bold mb-6">
            {t('comparison.title')}
          </h2>
        </motion.div>

        <motion.div
          className="overflow-hidden rounded-xl shadow-lg border border-gray-100"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <Table>
            <TableHeader>
              <TableRow className="bg-primary/5">
                <TableHead className="w-1/3 py-3 text-left text-gray-700 font-bold text-sm">Funktion</TableHead>
                <TableHead className="w-1/3 py-3 text-left text-gray-700 font-bold text-sm">Traditionel tilgang</TableHead>
                <TableHead className="w-1/3 py-3 text-left font-bold text-primary text-sm">
                  Offertio
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {comparisonData.map((item, index) => (
                <motion.tr
                  key={index}
                  className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  variants={itemVariants}
                >
                  <TableCell className="font-medium py-3 text-sm">{item.feature}</TableCell>
                  <TableCell className="py-3">
                    <div className="flex items-start">
                      <div className="flex-shrink-0 mr-2 mt-1">
                        <X className="h-4 w-4 text-red-500" />
                      </div>
                      <div className="text-gray-600 text-xs">{item.traditional}</div>
                    </div>
                  </TableCell>
                  <TableCell className="py-3">
                    <div className="flex items-start">
                      <div className="flex-shrink-0 mr-2 mt-1">
                        <Check className="h-4 w-4 text-green-500" />
                      </div>
                      <div className="text-gray-700 font-medium text-xs">{item.offertio}</div>
                    </div>
                  </TableCell>
                </motion.tr>
              ))}
            </TableBody>
          </Table>
        </motion.div>

        <motion.div
          className="mt-6 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          viewport={{ once: true }}
        >
        </motion.div>
      </div>
    </section>
  );
};
